import * as yup from 'yup';

const localization = {
  shouldUseOnlyUSAPhoneNumber: 'Please use only US phone number like this +11234567890.',
  USAPhoneNumberLength: (length: number) =>
    `Phone number should be 10 digits after county code (+1), but your is ${length}`,
  emailOrPhoneIsRequired: 'Email or Phone number is required.',
  invalidEmail: 'Please enter valid E-mail address.',
  emailIsRequired: 'Email is required.',
  shouldAgreeWithSMSAgreement:
    'Your consent to the sms agreement is required. Otherwise, you cannot register for the service.',
  shouldAgreeWithPrivacy:
    'Your consent to the Terms and Conditions is required. Otherwise, you cannot register for the service.',
};

export function prepareSchema({
  isEnabledSMSAgreement = false,
  isEnabledPhoneNumber = false,
  isEnabledCheckedAgreeWithPrivacy = false,
}) {
  let schema = yup.object().shape({});

  if (isEnabledPhoneNumber) {
    const contactSchema = yup
      .string()
      .test('email-or-us-phone', function (value = '') {
        if (isPhoneNumber(value)) {
          if (!isUSACountryCode(value)) {
            return this.createError({ message: localization.shouldUseOnlyUSAPhoneNumber });
          }
          if (!isUSAPhoneNumberByLength(value)) {
            return this.createError({
              message: localization.USAPhoneNumberLength(value.slice(2).length),
            });
          }
        } else if (!yup.string().email().isValidSync(value)) {
          return this.createError({ message: localization.invalidEmail });
        }
        return true;
      })
      .required(localization.emailOrPhoneIsRequired);

    schema = schema.shape({
      contact: contactSchema,
    });
  } else {
    schema = schema.shape({
      contact: yup.string().email(localization.invalidEmail).required(localization.emailIsRequired),
    });
  }

  if (isEnabledSMSAgreement) {
    schema = schema.shape({
      agreeWithSMSAgreement: yup.boolean().oneOf([true], localization.shouldAgreeWithSMSAgreement),
    });
  }

  if (isEnabledCheckedAgreeWithPrivacy) {
    schema = schema.shape({
      agreeWithPrivacy: yup.boolean().oneOf([true], localization.shouldAgreeWithPrivacy),
    });
  }

  return schema;
}

function isPhoneNumber(number: string) {
  return /^\d+$/.test(number) || /^\+\d+$/.test(number);
}

function isUSACountryCode(phoneNumber: string) {
  return /^\+1/.test(phoneNumber);
}

function isUSAPhoneNumberByLength(phoneNumber: string) {
  return /^\d{10}$/.test(phoneNumber.slice(2));
}
